import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import moment from "moment";
import TimePicker from 'rc-time-picker'

const NewDate    = moment().format('HH:mm')

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			shift_id    : "",
            start_moment: null,
            end_moment: null,
            start: "",
            end: "",
            name  : "",
            date        : "",
            dateNow     : NewDate,
			isButtonLoading: false,
			isLoading   : false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
    }

    handleTimePicker(momentValue, stateName, stateMomentName) {

        const newState = {}

        newState[stateName]       = momentValue.format("HH:mm:ss")
        newState[stateMomentName] = momentValue

        this.setState(newState)
    }

    handleSubmit() {
        let formData = new FormData();
        
        const config = {
			headers: { "content-type": "multipart/form-data" }
		};

		formData.append("shift_id", this.state.shift_id);
        formData.append("start", this.state.start);
        formData.append("end", this.state.end);
		formData.append("name", this.state.name);

		const url = this.props.mode === "Tambah" ? "shift/add" : "shift/edit";

		this.setState({ isButtonLoading: true });

		axios.post(url, formData, config)
			.then(response => {
                
				const result = response.data;

				if (result.success) {
					Alert.success(result.message);
					this.props.history.replace("/shift");
				} else {
					if (Array.isArray(result.message)) {
						result.message.map(item => {
							Alert.error(item);
							return true;
						});
					} else {
						Alert.error(result.message);
					}

					this.setState({ isButtonLoading: false });
				}
			})
			.catch(error => {
				console.log("ERROR", error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isButtonLoading: false });
			}); 
	}

	loadData() {

		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			axios({
				method: "get",
                url: "/shift/" + this.props.match.params.shift_id
            })

            .then(response => {

                const result = response.data;
                
                if(result.success){
                    this.setState({
                        shift_id: result.data.id,
                        start_moment: moment(result.data.start, "HH:mm"),
                        end_moment: moment(result.data.end, "HH:mm"),
                        name: result.data.name,
                    });

                }else{
                    Alert.error(result.message)
                }
               
                this.setState({ isLoading: false });
                console.log(response)
            })
            .catch(error => {
                console.log(error);
                Alert.error("Gagal terhubung ke server!");
                this.setState({ isLoading: false });
            });
		}
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card">
					<div className="card-header">{this.props.mode} Hari Libur</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">
                                        Nama Shift
                                    </label>
                                    <div className="col-md-4">
                                        <input
                                            name="name"
                                            type="text"
                                            className="form-control"
                                            placeholder="Nama (*Masuk Pagi/Masuk Siang Dll)"
                                            onChange={this.handleChange}
                                            value={this.state.name}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">
                                        Jam Masuk
                                    </label>
                                    <div className="col-md-4">
                                        <TimePicker
                                            name="jadwal_mulai"
                                            value={this.state.start_moment}
                                            showSecond={false}
                                            onChange={(value) => {
                                                this.handleTimePicker(value, "start", "start_moment")
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-md-2 form-control-label">
                                        Jam Pulang
                                    </label>
                                    <div className="col-md-4">
                                        <TimePicker
                                            name="jadwal_selesai"
                                            value={this.state.end_moment}
                                            showSecond={false}
                                            onChange={(value) => {
                                                this.handleTimePicker(value, "end", "end_moment")
                                            }}
                                        />
                                    </div>
                                </div>
							</div>
						)}
					</div>
					<div className="card-footer">
						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Simpan"}
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Shift/Forms.js